import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

// Assinatura digital (ICP-Brasil) do atestado com o certificado A1 do profissional.
export function useSignAttested() {
  const [isSigning, setSigning] = useState(false);

  const sign = useCallback(
    (patientId, attestedId, { certificatePassword, cidAuthorizedByPatient }) => {
      setSigning(true);
      return quarkusApi
        .post(
          `/atestado/${patientId}/${attestedId}/signature`,
          { certificatePassword, cidAuthorizedByPatient },
          { headers: { Authorization: sessionStorage.getItem('token') } },
        )
        .finally(() => setSigning(false));
    },
    [],
  );

  return { sign, isSigning };
}
